import script from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=a538a676&lang=less"

const __exports__ = script;

export default __exports__